var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userId)?_c('ks-user-name-view',_vm._b({attrs:{"user":_vm.user}},'ks-user-name-view',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }